/* ============================================================
   CELER · PDP v1 — assets/celer-pdp-v1.js
   ============================================================
   Adaptado de celer-pdp1-v8.html. Cambios vs el v8 estatico:
     - Selectores con prefijo .cpdp-* y IDs #cpdp* para no colisionar.
     - initColorSelector eliminado: en la PDP Liquid cada color es un
       producto separado, los thumbs son <a href> y el navegador navega.
       Se sustituye por initColorPrefetch que precarga el HTML del
       producto hermano al hover para que la navegacion sea instantanea.
     - Stock badge ya no se actualiza en cliente (Liquid lo renderiza
       server-side por producto). Se elimina updateStockBadge.
     - Anadido initAtc: form submit interceptado -> fetch /cart/add.js
       -> handleAtc visual feedback -> window.celerOpenCartDrawer().
       Si no existe celerOpenCartDrawer (drawer no montado), fallback
       a navegar /cart.
     - El boton emocional mantiene el patron 2-clicks del v8: primer
       click ATC, segundo click abre drawer.
   ============================================================ */

(function() {
  'use strict';

  /* ------------------------------------------------------------
     1. GALERIA
     ------------------------------------------------------------ */
  function initGallery() {
    const track = document.getElementById('cpdpGalleryTrack');
    if (!track) return;
    const dots = document.querySelectorAll('#cpdpGalleryDots .cpdp-gallery__dot');
    const thumbs = document.querySelectorAll('#cpdpGalleryThumbs .cpdp-gallery-thumb');
    const prev = document.querySelector('.cpdp-gallery__arrow--prev');
    const next = document.querySelector('.cpdp-gallery__arrow--next');

    const slideCount = Math.max(dots.length, thumbs.length, 1);
    let currentIdx = 0;

    function setActive(idx) {
      currentIdx = idx;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }

    function goToSlide(idx) {
      const clamped = Math.max(0, Math.min(slideCount - 1, idx));
      track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
      setActive(clamped);
    }

    track.addEventListener('scroll', function() {
      requestAnimationFrame(function() {
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== currentIdx) setActive(idx);
      });
    }, { passive: true });

    dots.forEach((d, i) => d.addEventListener('click', () => goToSlide(i)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => goToSlide(i)));
    if (prev) prev.addEventListener('click', () => goToSlide(currentIdx - 1));
    if (next) next.addEventListener('click', () => goToSlide(currentIdx + 1));
  }

  /* ------------------------------------------------------------
     3. COLOR PREFETCH (los thumbs son links a productos hermanos)
     ------------------------------------------------------------ */
  function initColorPrefetch() {
    const thumbs = document.querySelectorAll('[data-cpdp-prefetch]');
    const prefetched = {};
    thumbs.forEach(function(a) {
      a.addEventListener('mouseenter', function() {
        const href = a.getAttribute('href');
        if (!href || prefetched[href]) return;
        prefetched[href] = true;
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = href;
        document.head.appendChild(link);
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------
     4. ACCORDION
     ------------------------------------------------------------ */
  function initAccordion() {
    const items = document.querySelectorAll('.cpdp-accordion__item');
    items.forEach(function(item) {
      if (item.classList.contains('is-open')) {
        const content = item.querySelector('.cpdp-accordion__content');
        if (content) {
          requestAnimationFrame(function() {
            content.style.maxHeight = content.scrollHeight + 'px';
          });
        }
      }
    });
    items.forEach(function(item) {
      const trigger = item.querySelector('.cpdp-accordion__trigger');
      const content = item.querySelector('.cpdp-accordion__content');
      if (!trigger || !content) return;
      trigger.addEventListener('click', function() {
        const isOpen = item.classList.contains('is-open');
        if (isOpen) {
          content.style.maxHeight = '0px';
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
    window.addEventListener('resize', function() {
      items.forEach(function(item) {
        if (item.classList.contains('is-open')) {
          const content = item.querySelector('.cpdp-accordion__content');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  /* ------------------------------------------------------------
     5. FADE-IN AL SCROLL (bloque emocional)
     ------------------------------------------------------------ */
  function initFadeIn() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.cpdp-emo__photo, .cpdp-emo__text').forEach(function(el) {
        el.classList.add('is-visible');
      });
      return;
    }
    const targets = document.querySelectorAll('.cpdp-emo__photo, .cpdp-emo__text');
    const obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(function(t) { obs.observe(t); });
  }

  /* ------------------------------------------------------------
     6. STICKY BOTTOM CTA visibility (mobile only)
     ------------------------------------------------------------
     Simple scroll listener: el sticky aparece cuando hemos scroleado
     mas alla del bottom del .cpdp-product-info. IntersectionObserver
     fallaba con productInfo sticky (boundingClientRect raro).
  */
  function initStickyVisibility() {
    const sticky = document.getElementById('cpdpStickyCta');
    const productInfo = document.getElementById('cpdpProductInfo');
    if (!sticky || !productInfo) return;

    const mq = window.matchMedia('(max-width: 1023px)');
    let triggerY = 0;

    function recalcTrigger() {
      const rect = productInfo.getBoundingClientRect();
      triggerY = rect.bottom + window.scrollY;
    }

    function onScroll() {
      if (!mq.matches) {
        if (sticky.classList.contains('is-visible')) {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
        return;
      }
      const shouldShow = window.scrollY > triggerY;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    recalcTrigger();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function() {
      recalcTrigger();
      onScroll();
    }, { passive: true });
    window.addEventListener('orientationchange', function() {
      setTimeout(function() { recalcTrigger(); onScroll(); }, 100);
    }, { passive: true });
    window.addEventListener('load', function() { recalcTrigger(); onScroll(); });
    setTimeout(function() { recalcTrigger(); onScroll(); }, 1500);
    setTimeout(function() { recalcTrigger(); onScroll(); }, 3000);
    onScroll();
  }

  /* ------------------------------------------------------------
     7. ATC core: fetch + cart drawer
     ------------------------------------------------------------ */
  function showToast(text, isError) {
    const toast = document.getElementById('cpdpToast');
    if (!toast) return;
    toast.textContent = text;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    setTimeout(function() { toast.classList.remove('is-visible'); }, 2200);
  }

  function openCartDrawer() {
    if (typeof window.celerOpenCartDrawer === 'function') {
      try { window.celerOpenCartDrawer(); return true; } catch (err) {
        console.warn('[cpdp] celerOpenCartDrawer threw', err);
      }
    }
    return false;
  }

  function addToCart(form) {
    const fd = new FormData(form);
    const sectionsToRender = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(c) {
      if (c.dataset.sectionId) sectionsToRender.push(c.dataset.sectionId);
    });
    if (sectionsToRender.length > 0) fd.append('sections', sectionsToRender.join(','));
    fd.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function(r) {
      if (!r.ok) {
        return r.json().then(function(err) { throw err; });
      }
      return r.json();
    });
  }

  function dispatchCartUpdate(data) {
    if (data && data.sections) {
      try {
        Object.keys(data.sections).forEach(function(sectionId) {
          var newHtml = data.sections[sectionId];
          if (!newHtml) return;
          var tempDoc = new DOMParser().parseFromString(newHtml, 'text/html');
          var newCic = tempDoc.querySelector('cart-items-component[data-section-id="' + sectionId + '"]')
                    || tempDoc.querySelector('cart-items-component');
          var oldCic = document.querySelector('cart-items-component[data-section-id="' + sectionId + '"]')
                    || document.querySelector('cart-items-component');
          if (newCic && oldCic) {
            oldCic.innerHTML = newCic.innerHTML;
          }
        });
      } catch (err) {
        console.warn('[cpdp] morph cart-items-component failed', err);
      }
    }
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { source: 'celer-pdp-v1', data: data || null }
      }));
    } catch (err) {}
  }

  function visualConfirm(button, doneText, revertAfterMs) {
    if (!button) return;
    const originalText = button.textContent;
    button.classList.add('is-added');
    button.textContent = doneText || '✓ ANADIDO';
    if (revertAfterMs) {
      setTimeout(function() {
        button.classList.remove('is-added');
        button.textContent = originalText;
      }, revertAfterMs);
    }
  }

  /* ------------------------------------------------------------
     8. ATC handlers (form submit + sticky button + emocional)
     ------------------------------------------------------------ */
  function initAtc() {
    const form = document.getElementById('cpdpAtcForm');
    const stickyBuy = document.getElementById('cpdpStickyBuy');
    const emoCta = document.getElementById('cpdpEmoCta');

    if (form) {
      form.addEventListener('submit', function(e) {
        const submitter = e.submitter;
        if (!submitter || submitter.dataset.cpdpAtc === undefined) return;
        e.preventDefault();
        submitter.disabled = true;
        addToCart(form).then(function(data) {
          visualConfirm(submitter, submitter.dataset.cpdpAfter || '✓ ANADIDO AL CARRITO', 2500);
          showToast('✓ ANADIDO AL CARRITO');
          dispatchCartUpdate(data);
          setTimeout(function() {
            const opened = openCartDrawer();
            if (!opened) {
              window.location.href = '/cart';
            }
          }, 250);
        }).catch(function(err) {
          console.error('[cpdp] ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
        }).finally(function() {
          setTimeout(function() { submitter.disabled = false; }, 2500);
        });
      });
    }

    if (stickyBuy) {
      stickyBuy.addEventListener('click', function() {
        if (stickyBuy.disabled) return;
        stickyBuy.disabled = true;
        const fakeForm = form || buildFallbackForm();
        addToCart(fakeForm).then(function(data) {
          visualConfirm(stickyBuy, '✓ ANADIDO', 2500);
          showToast('✓ ANADIDO AL CARRITO');
          dispatchCartUpdate(data);
          setTimeout(function() {
            const opened = openCartDrawer();
            if (!opened) window.location.href = '/cart';
          }, 250);
        }).catch(function(err) {
          console.error('[cpdp] sticky ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
        }).finally(function() {
          setTimeout(function() { stickyBuy.disabled = false; }, 2500);
        });
      });
    }

    if (emoCta) {
      let added = false;
      let originalText = emoCta.textContent;
      emoCta.addEventListener('click', function() {
        if (added) {
          openCartDrawer();
          return;
        }
        if (emoCta.disabled) return;
        emoCta.disabled = true;
        const fakeForm = form || buildFallbackForm();
        addToCart(fakeForm).then(function(data) {
          added = true;
          emoCta.classList.add('is-added');
          emoCta.textContent = '✓ ANADIDO · VER CARRITO →';
          showToast('✓ ANADIDO AL CARRITO');
          dispatchCartUpdate(data);
          emoCta.disabled = false;
          setTimeout(function() {
            added = false;
            emoCta.classList.remove('is-added');
            emoCta.textContent = originalText;
          }, 5000);
        }).catch(function(err) {
          console.error('[cpdp] emo ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
          emoCta.disabled = false;
        });
      });
    }
  }

  function buildFallbackForm() {
    if (window._cpdpFallbackForm) return window._cpdpFallbackForm;
    const f = document.createElement('form');
    const root = document.querySelector('.cpdp-root');
    const variantId = root && root.dataset.cpdpVariantId;
    if (!variantId) return f;
    const id = document.createElement('input');
    id.name = 'id';
    id.value = variantId;
    f.appendChild(id);
    const qty = document.createElement('input');
    qty.name = 'quantity';
    qty.value = '1';
    f.appendChild(qty);
    window._cpdpFallbackForm = f;
    return f;
  }

  /* ------------------------------------------------------------
     9. SIZE SELECTOR (tee only)
     ------------------------------------------------------------
     Botones .cpdp-size-option llevan data-cpdp-variant-* attrs.
     Al clickar: actualiza label, hidden input, root data attr,
     texto del boton COMPRAR, precio del sticky CTA y visibilidad
     de los stock badges.
  */
  function initSizeSelector() {
    var options = document.querySelectorAll('.cpdp-size-option');
    if (!options.length) return;

    var sizeLabel = document.getElementById('cpdpSizeLabel');
    var variantInput = document.getElementById('cpdpVariantInput');
    var buyText = document.getElementById('cpdpBuyText');
    var buyBtn = document.getElementById('cpdpMainBuy');
    var stockMobile = document.getElementById('cpdpStockBadgeMobile');
    var stockDesktop = document.getElementById('cpdpStockBadgeDesktop');
    var stickyPrice = document.getElementById('cpdpStickyPrice');
    var root = document.querySelector('.cpdp-root');

    var THRESHOLD = 20; // sincronizado con el schema default

    options.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.getAttribute('aria-disabled') === 'true') return;

        options.forEach(function(o) { o.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var vid = btn.getAttribute('data-cpdp-variant-id');
        var vtitle = btn.getAttribute('data-cpdp-variant-title');
        var vprice = btn.getAttribute('data-cpdp-variant-price');
        var vstock = parseInt(btn.getAttribute('data-cpdp-variant-stock') || '0', 10);
        var vavailable = btn.getAttribute('data-cpdp-variant-available') === 'true';

        if (sizeLabel) sizeLabel.textContent = vtitle;
        if (variantInput) variantInput.value = vid;
        if (root) root.setAttribute('data-cpdp-variant-id', vid);
        if (buyText) buyText.textContent = vavailable ? 'AÑADIR AL CARRITO' : 'AGOTADO';
        if (buyBtn) buyBtn.disabled = !vavailable;
        if (stickyPrice) stickyPrice.textContent = vprice;

        var showStock = vavailable && vstock > 0 && vstock <= THRESHOLD;
        if (stockMobile) stockMobile.style.display = showStock ? '' : 'none';
        if (stockDesktop) stockDesktop.style.display = showStock ? '' : 'none';
      });
    });
  }

  /* ------------------------------------------------------------
     10. CROSS-SELL "COMPLETA TU EQUIPO" — + AÑADIR directo al carrito
     ------------------------------------------------------------
     Reutiliza addToCart() + dispatchCartUpdate() + openCartDrawer().
     Cada boton lleva data-variant-id del producto sugerido (monovariante).
     Al exito: abre el cart drawer (mismo patron que el ATC principal). */
  function initXsellAdd() {
    const buttons = document.querySelectorAll('[data-cpdp-xsell-add]');
    if (!buttons.length) return;
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        const originalText = btn.textContent;
        const f = document.createElement('form');
        const idInput = document.createElement('input');
        idInput.name = 'id';
        idInput.value = variantId;
        f.appendChild(idInput);
        const qtyInput = document.createElement('input');
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        f.appendChild(qtyInput);
        addToCart(f).then(function(data) {
          btn.classList.add('is-added');
          btn.textContent = '✓ AÑADIDO';
          showToast('✓ AÑADIDO AL CARRITO');
          dispatchCartUpdate(data);
          setTimeout(function() {
            const opened = openCartDrawer();
            if (!opened) window.location.href = '/cart';
          }, 250);
          setTimeout(function() {
            btn.classList.remove('is-added');
            btn.textContent = originalText;
          }, 2500);
        }).catch(function(err) {
          console.error('[cpdp] xsell ATC error', err);
          showToast('ERROR · INTENTA DE NUEVO', true);
        }).finally(function() {
          setTimeout(function() { btn.disabled = false; }, 2500);
        });
      });
    });
  }

  /* ------------------------------------------------------------
     11. CARRUSELES MOVIL con dots sincronizados (resenas + xsell)
     ------------------------------------------------------------
     Reutiliza el patron de initGallery: listener de scroll que calcula
     el indice activo por scrollLeft/stride y sincroniza los dots.
     Solo opera en movil (<1024px). Los dots se generan en runtime. */
  function initMobileCarousel(trackSel, dotsSel) {
    const track = document.querySelector(trackSel);
    const dotsWrap = document.querySelector(dotsSel);
    if (!track || !dotsWrap) return;
    const items = track.children;
    const count = items.length;
    if (count <= 1) { dotsWrap.style.display = 'none'; return; }
    dotsWrap.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cpdp-carousel-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Item ' + (i + 1));
      b.dataset.index = i;
      dotsWrap.appendChild(b);
    }
    const dots = dotsWrap.querySelectorAll('.cpdp-carousel-dot');
    let currentIdx = 0;
    function setActive(idx) {
      currentIdx = idx;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }
    function itemStride() {
      if (count < 2) return track.clientWidth;
      return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    }
    track.addEventListener('scroll', function() {
      requestAnimationFrame(function() {
        const stride = itemStride() || track.clientWidth;
        const idx = Math.round(track.scrollLeft / stride);
        const clamped = Math.max(0, Math.min(count - 1, idx));
        if (clamped !== currentIdx) setActive(clamped);
      });
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', function() {
      const stride = itemStride() || track.clientWidth;
      track.scrollTo({ left: i * stride, behavior: 'smooth' });
      setActive(i);
    }));
  }

  function initCarousels() {
    const mq = window.matchMedia('(max-width: 1023px)');
    if (!mq.matches) return;
    initMobileCarousel('.cpdp-reviews__grid', '.cpdp-reviews__dots');
    initMobileCarousel('.cpdp-suggested__grid', '.cpdp-suggested__dots');
  }

  /* ------------------------------------------------------------
     Boot
     ------------------------------------------------------------ */
  function boot() {
    initGallery();
    initColorPrefetch();
    initAccordion();
    initFadeIn();
    initStickyVisibility();
    initAtc();
    initSizeSelector();
    initXsellAdd();
    initCarousels();
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(boot, 0);
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();
